export enum API_NAMES {
  BILLINGS = 'billings',
  PATIENTS = 'patients',
  PATIENTS_EXTERNAL = 'patients-external',
  COMPANIES = 'companies',
  NOTES = 'notes',
  LOGGER = 'logger',
};
